<template>
  <card class="card-stats">
    <b-row>
      <div class="col-5" v-if="$slots.header">
        <div class="icon-big text-center">
          <slot name="header"></slot>
        </div>
      </div>
      <div class="col-7">
        <div class="numbers">
          <slot name="content">
            <p v-if="subTitle" class="card-category">{{subTitle}}</p>
            <h4 class="card-title">{{title}}</h4>
          </slot>
        </div>
      </div>
    </b-row>
    <div class="stats" slot="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </card>
</template>
<script>
  import Card from './Card.vue'
  export default {
    name: 'stats-card',
    components: {
      Card
    },
    props: {
      title: Number,
      subTitle: String
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Cards/StatsCard.vue